<!-- Hidden input (do not show label or wrapper) -->
<ng-container *ngIf="fields.fieldType === 'hidden'">
  <div [formGroup]="formGroup">
    <input
      autoFocus
      type="hidden"
      [formControlName]="fields.fieldName"
    />
  </div>
</ng-container>

<ng-container *ngIf="fields.fieldType !== 'hidden'">
  <div [formGroup]="formGroup" class="w-full py-1 px-2">
    <div class="gap-1 items-start mb-1">
      <!-- ✅ LABEL ABOVE -->
      <div *ngIf="labelAbove; else sideLayout">
        <label
          [ngClass]="{
            required: fields.isRequired == true && (disableFields === undefined || disableFields === null)
          }"
          class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 mb-1"
        >
          {{ formatDisplayName(fields.displayName) }}
        </label>

        <div>
          <ng-container *ngTemplateOutlet="switchBlock"></ng-container>
        </div>
      </div>

      <!-- ✅ SIDE LABEL -->
      <ng-template #sideLayout>
        <div class="grid grid-cols-12 gap-3 rounded-lg w-full items-center">
          <!-- LABEL -->
          <div class="col-span-4">
            <label
              [ngClass]="{
                required: fields.isRequired == true && (disableFields === undefined || disableFields === null)
              }"
              class="block text-2sm font-semibold text-gray-700 dark:text-gray-300 whitespace-normal break-words leading-tight"
            >
              {{ formatDisplayName(fields.displayName) }}
            </label>
          </div>

          <!-- INPUT -->
          <div class="col-span-8">
            <ng-container *ngTemplateOutlet="switchBlock"></ng-container>
          </div>
        </div>
      </ng-template>

      <!-- ✅ SWITCH BLOCK -->
      <ng-template #switchBlock>
        <div class="switch switch-sm me-auto">
          <input
            type="checkbox"
            [checked]="isActive"
            [attr.name]="fields.fieldName"
            [disabled]="disableFields === true"
            (change)="onSwitchChange($event)"
          />
          <span class="text-sm text-gray-800">
            {{
              formGroup.get(fields.fieldName)?.value === "Active"
                ? "Active"
                : "Inactive"
            }}
          </span>
        </div>
      </ng-template>
    </div>
  </div>
</ng-container>
